// Summer League horned-basketball mark (brand logo). Inline SVG so it needs no
// asset files and inherits crisp scaling. Unique gradient id per size+variant so
// multiple instances can coexist on the page.

export const SummerLeagueMark = ({
	size,
	idSuffix = "",
}: {
	size: number;
	idSuffix?: string;
}) => {
	const gid = `slball-${size}${idSuffix ? `-${idSuffix}` : ""}`;
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 100 100"
			style={{ display: "block" }}
		>
			<defs>
				<linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
					<stop offset="0" stopColor="#FF3D86" />
					<stop offset="1" stopColor="#FF7A3C" />
				</linearGradient>
			</defs>
			<polygon points="24,52 31,22 43,46" fill="#7C36E6" />
			<polygon points="76,52 69,22 57,46" fill="#7C36E6" />
			<polygon points="50,10 42,42 58,42" fill="#18E0A8" />
			<circle cx="50" cy="61" r="29" fill={`url(#${gid})`} />
			<g stroke="#121212" strokeWidth="3" strokeLinecap="round" fill="none">
				<line x1="50" y1="33" x2="50" y2="90" />
				<line x1="22" y1="61" x2="78" y2="61" />
				<path d="M31 37 C43 52 43 70 33 86" />
				<path d="M69 37 C57 52 57 70 67 86" />
			</g>
			<g stroke="#fff" strokeWidth="3.4" strokeLinecap="round" opacity=".95">
				<line x1="46" y1="42" x2="59" y2="86" />
				<line x1="55" y1="42" x2="67" y2="82" />
			</g>
		</svg>
	);
};

export default SummerLeagueMark;
